class Modifier {
  constructor(name, perform, performAsync) {
    this.name = name;
    this.perform = perform;
    this.performAsync = performAsync;
  }
}

export default Modifier;
